import { PureComponent } from 'preact-compat'
import { editProductAreas } from '@insided/shared/services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
// eslint-disable-next-line import/no-internal-modules
import ProductAreaSelect, { ProductAreaType } from '@insided/deprecated-control/product-areas/ProductAreaSelect'

interface ProductAreasProps {
  onProductAreasChanged: (newProductAreas: ProductAreaType[]) => void
  setIsLoading: (isLoading: boolean) => void
  productAreas: ProductAreaType[]
  contentType: ContentType
  privateId: number
  allProductAreas: ProductAreaType[]
}

class ProductAreas extends PureComponent<ProductAreasProps> {
  constructor (props: ProductAreasProps) {
    super(props)
    this.onChangeProductAreas = this.onChangeProductAreas.bind(this)
  }

  async onChangeProductAreas (newProductAreas: ProductAreaType[]) {
    const { contentType, privateId, onProductAreasChanged, setIsLoading } = this.props
    setIsLoading(true)
    const productAreaIds = newProductAreas.map(productArea => productArea.id)
    try {
      await editProductAreas(contentType, privateId, productAreaIds)
      onProductAreasChanged(newProductAreas)
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { allProductAreas, productAreas } = this.props
    return (
      <div className='topic-info__details-item'>
        <div className='form-group'>
          <label>Product Areas</label>
          <ProductAreaSelect
            allProductAreas={allProductAreas}
            selectedProductAreas={productAreas}
            onUpdate={this.onChangeProductAreas}
          />
        </div>
      </div>
    )
  }
}

export default ProductAreas
